import React from "react";

const ElipseIcon: (props: React.SVGProps<SVGSVGElement>) => JSX.Element = ({
  height = "24px",
  width = "24px",
  stroke = "black",
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={height}
      height={width}
      viewBox="0 0 6 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.444336 2.75C0.444336 1.23 1.67434 -1.86648e-07 3.19434 -1.20206e-07C4.71434 -5.3765e-08 5.94434 1.23 5.94434 2.75C5.94434 4.27 4.71434 5.5 3.19434 5.5C1.67434 5.5 0.444336 4.27 0.444336 2.75ZM4.44434 2.75C4.44434 2.06 3.88434 1.5 3.19434 1.5C2.50434 1.5 1.94434 2.06 1.94434 2.75C1.94434 3.44 2.50434 4 3.19434 4C3.88434 4 4.44434 3.44 4.44434 2.75Z"
        fill="#9CA3AF"
      />
      <path
        d="M0.444335 16.75C0.444335 15.23 1.67434 14 3.19434 14C4.71434 14 5.94434 15.23 5.94434 16.75C5.94434 18.27 4.71434 19.5 3.19434 19.5C1.67434 19.5 0.444335 18.27 0.444335 16.75ZM4.44434 16.75C4.44434 16.06 3.88434 15.5 3.19434 15.5C2.50434 15.5 1.94434 16.06 1.94434 16.75C1.94434 17.44 2.50434 18 3.19434 18C3.88434 18 4.44434 17.44 4.44434 16.75Z"
        fill="#9CA3AF"
      />
      <path
        d="M0.444336 9.75C0.444336 8.23 1.67434 7 3.19434 7C4.71434 7 5.94434 8.23 5.94434 9.75C5.94434 11.27 4.71434 12.5 3.19434 12.5C1.67434 12.5 0.444335 11.27 0.444336 9.75ZM4.44434 9.75C4.44434 9.06 3.88434 8.5 3.19434 8.5C2.50434 8.5 1.94434 9.06 1.94434 9.75C1.94434 10.44 2.50434 11 3.19434 11C3.88434 11 4.44434 10.44 4.44434 9.75Z"
        fill="#9CA3AF"
      />
    </svg>
  );
};

export default ElipseIcon;
